import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import TemplatesComponent from '../components/TemplatesComponent'

const mapStateToProps = (state) => {
  return {
    employee: state.employee,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesComponent)
